import {RECEIVE_LOCALE} from '../actions/action-types';

export default function i18n(state = {}, action) {
    switch (action.type) {
        case RECEIVE_LOCALE:
            return {
                ...state,
                translations: action.translations,
                locale: action.locale || state.locale
            };
        default:
            return state;
    }
}
